
import React from 'react';

const PriceDisplay = ({ priceInfo = [], priceTheme = "cat", zoom = 1, price_banner_settings = [] }) => {
  const { finalPrice, priceType, listing_price } = priceInfo;
  const { price_banner_fontSize } = price_banner_settings;

  // priceType can be: sooperdeal_price, offer_price, listing_price

  let discount;
  if (priceType === "offer_price") {
    discount = priceInfo?.finalPrice;
  }

  //

  if (priceTheme === "preview" || priceTheme === "shop_page") {
    return (
      <div style={{ ...styles.container, display: "left", zoom: zoom }}>
        <div style={{ display: "flex", flexDirection: "row", alignItems: "flex-end" }}>
          <Price price={discount || listing_price} />
          {discount && (
            <div style={{ opacity: 0.5, textDecoration: "line-through", marginLeft: 7, fontWeight: 200, fontSize: ".9rem", paddingBottom: 1 }}>
              {listing_price}
            </div>
          )}
        </div>
      </div>
    );
  }
  if (priceTheme === "category") {
    return (
      <div style={{ ...styles.container, display: "left" }}>
        <div style={{ display: "flex", flexDirection: "row" }}>
          <Price price={finalPrice} />
          {discount && <Discount discount={discount} style={{ marginRight: 4 }} />}
        </div>
        {discount && <RegularPrice regularPrice={discount} />}
      </div>
    );
  }
  if (priceTheme === "listing") {
    return (
      <div style={{ ...styles.container, display: "left", zoom: zoom }}>
        <div style={{ display: "flex", flexDirection: "row" }}>
          {discount && <Discount priceInfo={priceInfo} style={{ marginRight: 4 }} />}
          <Price price={finalPrice} />
        </div>

        {discount && (
          <div style={{ fontSize: ".8rem", color: "#757575", fontWeight: 400, display: "flex", flexDirection: "row", marginTop: 5 }}>
            Regular price:
            <RegularPrice regularPrice={listing_price} style={{ marginLeft: 5, fontSize: ".8rem" }} />
          </div>
        )}
      </div>
    );
  }

  if (priceTheme === "price_banner" && discount) {
    return (
      <div
        style={{
          ...styles.preview_banner,
          // if price_banner_fontSize than use it, if not skip it without define value!

          ...(price_banner_fontSize ? { fontSize: price_banner_fontSize } : {}),
        }}
      >
        -{Math.floor(100 - (finalPrice / listing_price) * 100)}% Off
      </div>
    );
  }

  return;
};

export const Discount = ({ priceInfo, style }) => {
  // calculate discountPercentage
  let discountPercentage = ((priceInfo.listing_price - priceInfo.finalPrice) / priceInfo.listing_price) * 100;

  return (
    <div style={{ ...styles.discount.container, ...style }}>
      <div style={{ ...styles.discount.text }}>-{Math.round(discountPercentage)}%</div>
    </div>
  );
};

export const RegularPrice = ({ regularPrice, text, style }) => {
  return (
    <div style={{ ...styles.regularPrice.container, ...style }}>
      {text && <div style={{ paddingRight: 10 }}>{text}</div>}
      <div style={{ ...styles.regularPrice.text }}>${regularPrice}</div>
    </div>
  );
};

export const Price = ({ price, style }) => {
  return (
    <div style={{ ...styles.price.container, ...style }}>
      <div style={{ ...styles.price.text }}>
        <div style={styles.price.dollar}>$</div>
        <div style={styles.price.price}>{String(price).split(".")[0]}</div>
        <div style={styles.price.cents}>{String(price).split(".")[1] || "00"}</div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
  },
  discount: {
    container: {
      display: "flex",
      backgroundColor: "#ec0303",
      padding: "2px 6px",
      borderRadius: 4,
      justifyContent: "center",
      alignItems: "center",
    },
    text: {
      fontSize: ".9rem",
      color: "#fff",
      fontWeight: 700,
    },
  },
  price: {
    container: {
      display: "flex",
      borderRadius: "8px",
    },
    text: {
      display: "flex",
      flexDirection: "row",
      fontSize: "1.5rem",
      color: "black",
    },
    price: {
      fontWeight: "bold",
      fontSize: "1.2rem",
      padding: "0px 1px",
    },
    dollar: {
      fontSize: ".9rem",
      fontWeight: "200",
      paddingTop: ".05rem",
    },
    cents: {
      fontSize: ".9rem",
      fontWeight: "200",
      paddingTop: ".05rem",
    },
  },
  regularPrice: {
    container: {
      display: "flex",
      paddingTop: 0,
      color: "#757575",
      fontSize: ".9rem",
      fontWeight: 400,
    },
    text: {
      textDecoration: "line-through", // Strikethrough for regular price
    },
  },
  // preview banner
  preview_banner: {
    position: "relative",
    zIndex: 1,
    background: "#EC0303",
    borderRadius: "6px 0 0 0",
    padding: "2px 14px 2px 6px",
    color: "white",
    fontSize: ".60rem",
    fontWeight: 600,
    clipPath: "polygon(0 0, 100% 0%, 92% 100%, 0% 100%)",
    width: "auto",
    textAlign: "center",
  },
};

export default PriceDisplay;
